import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';

const TableViewTr = (props) => <tr className={styles.TableViewTr}>
  {props.children}
</tr>;

TableViewTr.propTypes = {
  children: PropTypes.node,
};

export default TableViewTr;



// WEBPACK FOOTER //
// ./components/TableView/TableViewTr/index.jsx